/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentKeyAuthClientChoice,
  AgentKeyAuthClientChoice$Outbound,
  AgentKeyAuthClientChoice$outboundSchema,
} from "./agentkeyauthclientchoice.js";
import {
  ExtendAgentKeyGrantForm,
  ExtendAgentKeyGrantForm$Outbound,
  ExtendAgentKeyGrantForm$outboundSchema,
} from "./extendagentkeygrantform.js";

export type ExtendAgentKeysForm = {
  /**
   * The agent whose keys gain the grants
   */
  agentId: string;
  /**
   * The upstream credential each key uses on the servers it gains, checked as at issuance. Recorded only on keys that gain that server.
   */
  authClientChoices?: Array<AgentKeyAuthClientChoice> | undefined;
  /**
   * Server grants to add to each key
   */
  requestedGrants: Array<ExtendAgentKeyGrantForm>;
};

/** @internal */
export type ExtendAgentKeysForm$Outbound = {
  agent_id: string;
  auth_client_choices?: Array<AgentKeyAuthClientChoice$Outbound> | undefined;
  requested_grants: Array<ExtendAgentKeyGrantForm$Outbound>;
};

/** @internal */
export const ExtendAgentKeysForm$outboundSchema: z.ZodMiniType<
  ExtendAgentKeysForm$Outbound,
  ExtendAgentKeysForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    authClientChoices: z.optional(
      z.array(AgentKeyAuthClientChoice$outboundSchema),
    ),
    requestedGrants: z.array(ExtendAgentKeyGrantForm$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      authClientChoices: "auth_client_choices",
      requestedGrants: "requested_grants",
    });
  }),
);

export function extendAgentKeysFormToJSON(
  extendAgentKeysForm: ExtendAgentKeysForm,
): string {
  return JSON.stringify(
    ExtendAgentKeysForm$outboundSchema.parse(extendAgentKeysForm),
  );
}
